import * as classnames from 'classnames/bind'
import Button from 'components/button'
import { isEmpty, startsWith } from 'lodash'
import * as React from 'react'
import { Children, Component, ReactElement, ReactNode } from 'react'
import UrlUtil from 'utilities/url_util'
import styles from './side_nav_collapse_item.module.scss'

type Props = {
  icon?: ReactElement
  title: string
  children: ReactNode[] | ReactNode
}

const cx = classnames.bind(styles)
export default class SideNavCollapseItem extends Component<Props, { isOpen: boolean }> {
  children: any

  constructor(props) {
    super(props)
    this.state = {
      isOpen: false
    }
    // pathを判定する処理は配列で行うので変換しておく
    this.children = Children.toArray(props.children)
  }

  componentDidMount() {
    const paths = this.children.map(node => node.props.belongs || node.props.path)
    const collapsed = paths.find(path => startsWith(UrlUtil.getUrlPathname(), path))

    if (collapsed) {
      this.show()
    }
  }

  toggle() {
    const { isOpen } = this.state

    this.setState({
      isOpen: !isOpen
    })
  }

  show() {
    this.setState({
      isOpen: true
    })
  }

  render() {
    const { icon, title } = this.props
    const { isOpen } = this.state
    const enabledChildren = this.children.filter(child => child.props.enable)

    if (isEmpty(enabledChildren)) {
      return null
    }

    const isCollapseDisabled = enabledChildren.length === 1
    const newChildren = Children.map(enabledChildren, child => {
      const newProps = {
        ...child.props,
        isCollapseDisabled,
        icon: isCollapseDisabled ? child.props.icon : null
      }
      return React.cloneElement(child, newProps)
    })

    if (isCollapseDisabled) {
      return newChildren
    }

    return (
      <div className={styles.group}>
        <Button className={cx(styles.parentItem, { parentItemCollapsed: isOpen })} onClick={() => this.toggle()}>
          {icon || null}
          {title}
        </Button>
        <div className={cx(styles.children, { childrenCollapsed: isOpen })}>{newChildren}</div>
      </div>
    )
  }
}
